// const Glide = require('@glidejs/glide');

const bootstrap = () => {
	document.querySelectorAll('.js-alpine-carousel')
		.forEach( $el => bootstrapCarousel($el) )
	;
};

const bootstrapCarousel = ($el) => {
	$el.setAttribute('x-data', 'carousel');
	$el.setAttribute('x-on:resize.window.debounce.200ms', 'onResize');
	const $track = $el.querySelector('.wpb_wrapper');
	$track.setAttribute('x-ref', 'slider');

	const $nav = document.createElement('nav');
	$nav.classList.add('c-iconbox-carousel__nav');
	$nav.insertAdjacentHTML('beforeend', `<span class="c-iconbox-carousel__control--prev" @click="prev">${prev_icon}</span>`);
	$nav.insertAdjacentHTML('beforeend', `<span class="c-iconbox-carousel__control--next" @click="next">${next_icon}</span>`);
	$nav.insertAdjacentHTML('beforeend', '<div class="c-iconbox-carousel__nav-fill"></div>');
	$track.parentNode.appendChild($nav);
};

window.addEventListener('alpine:init', () => {
	bootstrap();
});

export default() => ({
	$container: null,
	$main: null,
	skip: 1,
	gap: 20,
	init() {
		this.$main = document.querySelector('#main');
		this.$container = document.querySelector('#content-wrap');
		this.setGutters();
	},
	next() {
		this.to( (current, offset) => current + (offset * this.skip) );
	},
	prev() {
		this.to( (current, offset) => current - (offset * this.skip) );
	},
	to(strategy) {
		const current = this.$refs.slider.scrollLeft;
		let offset = this.$refs.slider.firstElementChild.getBoundingClientRect().width + this.gap;
		const mod = current % offset;
		if ( mod > 0 ) {
			offset = mod;
		}

		this.$refs.slider.scrollTo({ left: strategy(current, offset), behavior: 'smooth' });
	},
	onResize() {
		this.setGutters();
	},
	setGutters() {
		const viewport_width = parseInt(this.$main.clientWidth, 10);
		const container_width = parseInt(this.$container.clientWidth, 10);
		const gutter = (viewport_width - container_width) / 2;
		this.$root.style.setProperty('--page-gutter', gutter + 'px');
		this.$root.style.setProperty('--neg-page-gutter', '-' + gutter + 'px');
	}
});

const prev_icon = '<svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none">\
	<rect y="33" width="33" height="33" rx="4" transform="rotate(-90 0 33)" fill="#FF007A"/>\
	<path fill-rule="evenodd" clip-rule="evenodd" d="M14.2772 23.7347C14.1092 23.8747 13.8924 23.9422 13.6746 23.9224C13.4568 23.9026 13.2557 23.7971 13.1156 23.6291L7.61619 17.0291C7.54375 16.9463 7.48861 16.8499 7.454 16.7455C7.41939 16.641 7.40602 16.5307 7.41466 16.4211C7.4233 16.3114 7.45379 16.2046 7.50434 16.1069C7.55488 16.0092 7.62445 15.9225 7.70896 15.8521C7.79347 15.7817 7.89121 15.7289 7.99643 15.6968C8.10165 15.6647 8.21223 15.654 8.32166 15.6652C8.43108 15.6765 8.53715 15.7096 8.63362 15.7624C8.73009 15.8153 8.81501 15.8869 8.88339 15.9731L14.3828 22.5731C14.5228 22.7412 14.5903 22.958 14.5705 23.1758C14.5507 23.3936 14.4452 23.5946 14.2772 23.7347Z" fill="white"/>\
	<path fill-rule="evenodd" clip-rule="evenodd" d="M14.2772 9.26994C14.4452 9.41001 14.5507 9.61105 14.5705 9.82888C14.5903 10.0467 14.5228 10.2635 14.3828 10.4315L8.88339 17.0315C8.81501 17.1177 8.73009 17.1893 8.63362 17.2422C8.53715 17.2951 8.43108 17.3281 8.32166 17.3394C8.21223 17.3507 8.10165 17.34 7.99643 17.3079C7.89121 17.2758 7.79347 17.223 7.70896 17.1525C7.62445 17.0821 7.55488 16.9955 7.50434 16.8978C7.45379 16.8001 7.4233 16.6932 7.41466 16.5836C7.40602 16.4739 7.41939 16.3636 7.454 16.2592C7.48861 16.1548 7.54375 16.0583 7.61619 15.9755L13.1156 9.37554C13.2557 9.20755 13.4568 9.10206 13.6746 9.08226C13.8924 9.06246 14.1092 9.12997 14.2772 9.26994Z" fill="white"/>\
	<path fill-rule="evenodd" clip-rule="evenodd" d="M8.25 16.4992C8.25 16.2804 8.33692 16.0706 8.49164 15.9159C8.64635 15.7611 8.8562 15.6742 9.075 15.6742L24.75 15.6742C24.9688 15.6742 25.1786 15.7611 25.3334 15.9159C25.4881 16.0706 25.575 16.2804 25.575 16.4992C25.575 16.718 25.4881 16.9279 25.3334 17.0826C25.1786 17.2373 24.9688 17.3242 24.75 17.3242L9.075 17.3242C8.8562 17.3242 8.64635 17.2373 8.49164 17.0826C8.33692 16.9279 8.25 16.718 8.25 16.4992Z" fill="white"/>\
</svg>';

const next_icon = '<svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none">\
	<rect x="33" width="33" height="33" rx="4" transform="rotate(90 33 0)" fill="#FF007A"/>\
	<path fill-rule="evenodd" clip-rule="evenodd" d="M18.7228 9.26529C18.8908 9.12531 19.1076 9.05781 19.3254 9.07761C19.5432 9.09741 19.7443 9.2029 19.8844 9.37089L25.3838 15.9709C25.4562 16.0537 25.5114 16.1501 25.546 16.2545C25.5806 16.359 25.594 16.4693 25.5853 16.5789C25.5767 16.6886 25.5462 16.7954 25.4957 16.8931C25.4451 16.9908 25.3756 17.0775 25.291 17.1479C25.2065 17.2183 25.1088 17.2711 25.0036 17.3032C24.8983 17.3353 24.7878 17.346 24.6783 17.3348C24.5689 17.3235 24.4628 17.2904 24.3664 17.2376C24.2699 17.1847 24.185 17.1131 24.1166 17.0269L18.6172 10.4269C18.4772 10.2588 18.4097 10.042 18.4295 9.82422C18.4493 9.6064 18.5548 9.40536 18.7228 9.26529Z" fill="white"/>\
	<path fill-rule="evenodd" clip-rule="evenodd" d="M18.7228 23.7301C18.5548 23.59 18.4493 23.3889 18.4295 23.1711C18.4097 22.9533 18.4772 22.7365 18.6172 22.5685L24.1166 15.9685C24.185 15.8823 24.2699 15.8107 24.3664 15.7578C24.4628 15.7049 24.5689 15.6719 24.6783 15.6606C24.7878 15.6493 24.8983 15.66 25.0036 15.6921C25.1088 15.7242 25.2065 15.777 25.291 15.8475C25.3756 15.9179 25.4451 16.0045 25.4957 16.1022C25.5462 16.1999 25.5767 16.3068 25.5853 16.4164C25.594 16.5261 25.5806 16.6364 25.546 16.7408C25.5114 16.8452 25.4562 16.9417 25.3838 17.0245L19.8844 23.6245C19.7443 23.7924 19.5432 23.8979 19.3254 23.9177C19.1076 23.9375 18.8908 23.87 18.7228 23.7301Z" fill="white"/>\
	<path fill-rule="evenodd" clip-rule="evenodd" d="M24.75 16.5008C24.75 16.7196 24.6631 16.9294 24.5084 17.0841C24.3536 17.2389 24.1438 17.3258 23.925 17.3258L8.25 17.3258C8.03119 17.3258 7.82135 17.2389 7.66664 17.0841C7.51192 16.9294 7.425 16.7196 7.425 16.5008C7.425 16.282 7.51192 16.0721 7.66664 15.9174C7.82135 15.7627 8.03119 15.6758 8.25 15.6758L23.925 15.6758C24.1438 15.6758 24.3536 15.7627 24.5084 15.9174C24.6631 16.0721 24.75 16.282 24.75 16.5008Z" fill="white"/>\
</svg>';
